import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash/lang';

import { preparePersonnelInfoState } from 'components/pages/study/StudyDetails/SiteDetails/AddOrEditPersonnelModal/utils';

import { UserApiApi } from '../../../../../../api';
import ModalBoxes from '../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../../common/general/Button';
import { NS_COMMON } from '../../../../../../services/i18n/namespaces';

import AddRole from './AddRole/AddRole';
import CurrentRoles from './CurrentRoles/CurrentRoles';
import PersonalInformation from './PersonalInformation/PersonalInformation';

import './AddOrEditPersonnelModal.scss';

const defaultPersonnelInfo = {
  id: null,
  email: '',
  firstName: '',
  lastName: '',
  preferredLanguage: 'EN',
  startDate: null
};

export default function AddOrEditPersonnelModal({
  ssuId,
  studyId,
  studyName,
  isGroupAssignStudy,
  siteName,
  personnelId,
  email,
  modalBox
}) {
  const { t } = useTranslation();

  const [personnelInfo, setPersonnelInfo] = useState(null);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (personnelId && ssuId) {
      UserApiApi.getPersonnelDetails(ssuId, personnelId).then(({ data }) => {
        setPersonnelInfo(preparePersonnelInfoState(data.personnelInfo));
        setRoles(data?.roles);
      });
    } else {
      setPersonnelInfo({ ...defaultPersonnelInfo, email });
    }
  }, [ssuId, personnelId, email, setPersonnelInfo, setRoles]);

  return (
    <>
      <ModalBoxes.Body>
        {personnelInfo && (
          <PersonalInformation
            ssuId={ssuId}
            personnelInfo={personnelInfo}
            noActiveRole={isEmpty(roles)}
            setPersonnelInfo={setPersonnelInfo}
            setRoles={setRoles}
          />
        )}
        {personnelInfo?.id && (
          <div className="add-or-edit-personnel-modal-section">
            <CurrentRoles
              personnelId={personnelInfo?.id}
              roles={roles}
              setPersonnelInfo={setPersonnelInfo}
              setRoles={setRoles}
            />
            <AddRole
              ssuId={ssuId}
              studyId={studyId}
              studyName={studyName}
              isGroupAssignStudy={isGroupAssignStudy}
              siteName={siteName}
              personnelId={personnelInfo?.id}
              setPersonnelInfo={setPersonnelInfo}
              setRoles={setRoles}
            />
          </div>
        )}
      </ModalBoxes.Body>
      <ModalBoxes.Footer>
        <Button onClick={modalBox.close}>{t('close', { ns: NS_COMMON })}</Button>
      </ModalBoxes.Footer>
    </>
  );
}

AddOrEditPersonnelModal.className = 'add-or-edit-personnel-modal';
AddOrEditPersonnelModal.size = 'w1100';
